import { i18n } from "@/locale";

const MallList = () => import("@/views/mall/pc/list.vue");
const MallSingle = () => import("@/views/mall/pc/single.vue");
const MallMobileList = () => import("@/views/mall/m/list.vue");
const MallMobileSingle = () => import("@/views/mall/m/single.vue");
const MallMobileCart = () => import("@/views/mall/m/cart.vue");
const MallMobileFav = () => import("@/views/mall/m/fav.vue");

const {
    global: { t },
} = i18n;

import layout from "@/layouts/dashboard";
const DefaultLayout = () => import("@/layouts/default.vue");

export default [
    {
        path: "/mall/pc",
        name: "mall-pc",
        component: layout,
        children: [
            // 商品列表
            {
                path: "list",
                name: "mall-pc-list",
                component: MallList,
                meta: {
                    title: t("mall.route.title"),
                    desc: t("mall.route.desc"),
                },
            },
            {
                path: "single/:uuid",
                name: "mall-pc-single",
                component: MallSingle,
                meta: {
                    title: t("mall.route.title"),
                    desc: t("mall.route.desc"),
                },
            },
        ],
    },
    {
        path: "/mall/m",
        name: "mall-m",
        component: DefaultLayout,
        children: [
            // 商品列表
            {
                path: "list",
                name: "mall-m-list",
                component: MallMobileList,
                meta: {
                    title: t("mall.route.title"),
                },
            },
            {
                path: "single/:uuid",
                name: "mall-m-single",
                component: MallMobileSingle,
                meta: {
                    title: t("mall.route.title"),
                },
            },
            // 购物车
            {
                path: "cart",
                name: "mall-m-cart",
                component: MallMobileCart,
                meta: {
                    title: t("mall.cart.title"),
                },
            },
            // 收藏夹
            {
                path: "fav",
                name: "mall-m-fav",
                component: MallMobileFav,
                meta: {
                    title: t("mall.fav.title"),
                },
            },
        ],
    },
];
